import React from "react";

export default function ButtonRestartApp() {
  function restartApp() {
    window.location.reload();
  }
  return (
    <button className="btn white" onClick={restartApp}>
      Restart app
    </button>
  );
}
